require('initializers/gettext').default(__TRANSLATIONS__.gettext.hi); // eslint-disable-line no-undef
require('initializers/i18n').default('hi', __TRANSLATIONS__.i18n.hi); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/hi');
require('jquery-ui/ui/i18n/datepicker-hi');
require('dayjs/locale/hi');
